import React, { useState, useRef, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import AnimateHeight from "react-animate-height";
import styled from "styled-components";
import IcomoonReact from "icomoon-react";
import { device } from "../../services/styles";
import iconSet from "../../fonts/selection.json";

const Box = styled.div`
  background-color: #f1f1f1;
  padding: 20px 10px 20px 10px;
  margin: 0 0 20px 0;
  width: 100%;
  @media ${device.tablet} {
    width: 400px;
    padding: 20px;
    margin-right: 20px;
  }
  .wysiwyg ul {
    margin-bottom: -18px;
  }
`;
export const Header = styled.p`
  font-size: 20px;
  line-height: 24px;
  font-weight: 900;
  text-transform: uppercase;
  margin: 0 0 20px 0;
  width: 100%;
  cursor: pointer;
  position: relative;
`;

function TableOfContent({ content }) {
  const initialHeight = 64;
  const [height, setHeight] = useState(initialHeight);
  const toggleCollapse = () =>
    setHeight(height === initialHeight ? "auto" : initialHeight);
  return (
    <AnimateHeight duration={500} height={height} style={{ marginBottom: 20 }}>
      <Box>
        <Header onClick={toggleCollapse}>
          spis treŚci
          <IcomoonReact
            iconSet={iconSet}
            color={"#000"}
            icon={"right-arrow"}
            size={22}
            style={{
              position: "absolute",
              top: 0,
              right: 10,
              transition: "transform .2s ease-in-out",
              transform:
                height === initialHeight ? "rotate(90deg)" : "rotate(-90deg)",
            }}
          />
        </Header>
        <div className={"wysiwyg"}>{ReactHtmlParser(content)}</div>
      </Box>
    </AnimateHeight>
  );
}

export default TableOfContent;
